import React from 'react';
import { connect } from 'react-redux';
import * as questionActions from '../redux/actions/questionActions';
import { Redirect } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import Question from './Question';
class Home extends React.Component {
  getQuestions() {
    (this.props as any).getAllQuestions();
    let ans = [];
    const all = (this.props as any).allQuestions;
    const loggedUser = (this.props as any).loggedUser;

    if (this.state.isAnswered === true) {
      try {
      } catch (e) {}
      ans = all.filter((q:any) => {
        const res =
          q.optionOne.votes.includes(loggedUser.id) ||
          q.optionTwo.votes.includes(loggedUser.id);
        return res;
      });
    } else {
      ans = all.filter((q:any) => {
        const res =
          !q.optionOne.votes.includes(loggedUser.id) &&
          !q.optionTwo.votes.includes(loggedUser.id);
        return res;
      });
    }
    return ans.sort((a:any, b:any) => (a.timestamp < b.timestamp ? 1 : -1));
  }

  state = { isAnswered: false };

  componentDidMount() {
    try {
      if ((this.props as any).location.state && (this.props as any).location.state.isAnswered)
        this.setState({ isAnswered: (this.props as any).location.state.isAnswered });
    } catch {
      this.setState({ isAnswered: false });
    }
  }

  render() {
    if ((this.props as any).isLogged === false) {
      return <Redirect to="/login" />;
    }
    return (this.props as any).isLogged === true ? (
      <>
        <div className="container center col-12 viewBtn">
          <div className="col-3"></div>
          <Button
            className={
              this.state.isAnswered === true
                ? 'btn btn-sm col-3 btn-secondary'
                : 'btn btn-sm col-3 btn-primary'
            }
            onClick={() => this.setState({ isAnswered: false })}
            style={{ margin: '2px' }}
          >
            Unanswered Questions
          </Button>
          <Button
            className={
              this.state.isAnswered === true
                ? 'btn btn-sm col-3 btn-primary'
                : 'btn btn-sm col-3 btn-secondary'
            }
            onClick={() => this.setState({ isAnswered: true })}
          >
            Answered Questions
          </Button>
          <div className="col-3"></div>
        </div>
        <div className="row justify-content-center">
          <div className="col-5">
            {this.getQuestions().map((q:any) => (
              <Question question={q!} key={q.id!} />
            ))}
          </div>
        </div>
      </>
    ) : (
      <></>
    );
  }
}

const mapStateToProps = (state:any) => {
  return {
    allQuestions: state.questionReducer.allQuestions,
    loggedUser: state.userReducer.loggedUser,
    isLogged: state.userReducer.loggedUser.id ? true : false,
  };
};

const mapDispatchToProps = (dispatch:any) => {
  return {
    getAllQuestions: () => dispatch(questionActions.getAllQuestions()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);
